module.exports = __webpack_public_path__ + "static/media/axios-activation.9147ed58.png";